// Module
var code = "<button data-bind=\"click:  toggle\">\n  <fc-icon params=\"name: 'chevron-bottom', color: 'secondary'\"></fc-icon>\n</button>\n";
// Exports
module.exports = code;